import Phaser from 'phaser';
import { ELEVATOR_SPRITES } from '@campus/core';

/** Images 0 → 7 : ouverture ; 7 → 13 : fermeture (planches LimeZu de l'ascenseur du métro). */
const OPEN_END = 7;
const LAST_FRAME = 13;
const FRAME_RATE = 10;
/** Portes fermées sur la cabine : dernière image de la fermeture. */
const SHUT_AFTER_MS = ((LAST_FRAME - OPEN_END) * 1000) / FRAME_RATE;

/**
 * ElevatorDoor — ascenseur du métro LimeZu (2 × 2 cases), posé sur une zone
 * « elevator ». Trois planches de même découpe : voyants éteints, flèche qui
 * monte, flèche qui descend ; la fermeture après un choix d'étage se joue sur
 * la planche du sens du trajet. Origine bas-gauche, comme AnimatedDoor.
 */
export class ElevatorDoor extends Phaser.GameObjects.Sprite {
  private isOpen = false;
  private closingSince = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, ELEVATOR_SPRITES.off, 0);
    this.setOrigin(0, 1);
    for (const key of Object.values(ELEVATOR_SPRITES)) {
      if (scene.anims.exists(`${key}_open`)) continue;
      scene.anims.create({ key: `${key}_open`, frames: scene.anims.generateFrameNumbers(key, { start: 0, end: OPEN_END }), frameRate: FRAME_RATE, repeat: 0 });
      scene.anims.create({ key: `${key}_close`, frames: scene.anims.generateFrameNumbers(key, { start: OPEN_END, end: LAST_FRAME }), frameRate: FRAME_RATE, repeat: 0 });
    }
  }

  open(): void {
    if (this.isOpen) return;
    this.isOpen = true;
    this.play(`${ELEVATOR_SPRITES.off}_open`);
  }

  /** Ferme les portes ; `direction` allume la flèche du trajet pendant la fermeture. */
  close(direction?: 'up' | 'down'): void {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.closingSince = this.scene.time.now;
    const key = direction ? ELEVATOR_SPRITES[direction] : ELEVATOR_SPRITES.off;
    this.play(`${key}_close`);
    this.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
      if (!this.isOpen) this.setTexture(ELEVATOR_SPRITES.off, 0);
    });
  }

  /** Portes complètement fermées (fin de l'animation) : ce qui est dans la cabine ne se voit plus. */
  isShut(): boolean {
    return !this.isOpen && this.scene.time.now - this.closingSince >= SHUT_AFTER_MS;
  }
}
